import React from "react";
import PropTypes from "prop-types";
import Marquee from "react-fast-marquee";
import PartnersBannerPartner from "./PartnersBannerPartner";
import { useMediaQuery } from "react-responsive";

//style rules
import { Sizes } from "../styles";

const PartnersBanner = ({ marqueeElements }) => {
	const isDesktopOrLaptop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});

	let marqueeArray;
	// the marquee will show gaps if the amount of logos doesn't stretch across the whole screen
	// this will make it so there are always 10-12 logos shown
	switch (true) {
			case marqueeElements.length <= 3:
				marqueeArray = [
					...marqueeElements,
					...marqueeElements,
					...marqueeElements,
				];
				break;
			case marqueeElements.length <= 10:
				marqueeArray = [...marqueeElements, ...marqueeElements];
				break;
			case marqueeElements.length >= 12:
				marqueeElements.length = 12;
				marqueeArray = [...marqueeElements];
				break;
			default:
				marqueeArray = [...marqueeElements];
	}

	const marqueeConfig = isDesktopOrLaptop
		? {
			speed: 50,
			gradient: false,
			pauseOnHover: true,}
		: { speed: 50, gradient: false, pauseOnClick: true };

	return (
		<div className="partners-banner__container">
			<Marquee
				className="partners-banner__container__marquee"
				{...marqueeConfig}
			>
				{marqueeArray.map((element, i) => (
					<PartnersBannerPartner
						key={`${element.dataset.partnerTitle}-${i}`}
						partner={element.dataset}
						index={i}
					/>
				))}
			</Marquee>
		</div>
	);
};

PartnersBanner.propTypes = {
	marqueeElements: PropTypes.array,
};

export default PartnersBanner;
